module.exports = __webpack_public_path__ + "img/banner-0.8253fe75.jpg";